/** OWN-318: the FAB would cover the composer on the conversations screens and the canvas in the flow editor. */
export function isAssistantFabHidden(pathname: string): boolean {
  return /\/conversations(\/|$)/.test(pathname) || /\/flows\/[^/]+\/edit(\/|$)/.test(pathname);
}
